var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.015,
    height: 21.953,
    viewBox: "0 0 24.015 21.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1613",
    "data-name": "Group 1613",
    transform: "translate(-754.087 -338.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M264.094,62.844a1.234,1.234,0,1,0,0,2.468,1.234,1.234,0,0,0,0-2.468",
    transform: "translate(502 291)",
    fill: "#ff3056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M275.517,67.218a4.214,4.214,0,0,0,.01-4.266L267.8,49.564a4.261,4.261,0,0,0-7.4-.005l-7.74,13.4a4.275,4.275,0,0,0,3.7,6.408H271.8a4.252,4.252,0,0,0,3.712-2.152m-1.678-.968a2.332,2.332,0,0,1-2.039,1.18H256.358a2.3,2.3,0,0,1-2.014-1.155,2.337,2.337,0,0,1,0-2.354l7.741-13.4a2.325,2.325,0,0,1,4.038.005l7.736,13.4a2.3,2.3,0,0,1-.015,2.325",
    transform: "translate(502 291)",
    fill: "#ff3056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M263.788,54.18a1.343,1.343,0,0,0-.953,1.348c.03.39.055.785.084,1.175.084,1.486.168,2.942.252,4.428a.905.905,0,0,0,.923.869.922.922,0,0,0,.923-.9c0-.306,0-.587.03-.9.054-.953.113-1.906.168-2.859.029-.617.084-1.234.113-1.851a1.524,1.524,0,0,0-.113-.617,1.238,1.238,0,0,0-1.427-.7",
    transform: "translate(502 291)",
    fill: "#ff3056"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.7bc3b3c0153744a35816f640163e05cb.svg";
export { ForwardRef as ReactComponent };